module.exports = __webpack_public_path__ + "static/img/1.9916474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/33/1.png
// module id = NV3a
// module chunks = 0